var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJdFnlBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 16,
    viewBox: "0 0 78 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99379 6C9.8539 6 9.74316 6 9.68487 6L9 10C9.06703 10 9.1836 10 9.33223 10C10.1774 10 11.6404 9.73816 11.9551 7.9805C12.0659 7.37604 11.9726 6.89694 11.6637 6.56267C11.2295 6.07242 10.4309 6 9.99379 6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM2.59862 11.8841C2.5063 11.885 2.41406 11.8786 2.32276 11.8648L2.26207 11.8621L2.50759 9.98069H2.58759C5.32025 9.98069 5.82999 4.31809 5.8399 4.20803L5.84 4.2069V4.15172H7.73241V4.22069C6.67035 11.3297 3.53379 11.8841 2.59862 11.8841ZM7.05379 11.6607H9.65517C12.1379 11.6607 13.5752 9.71862 13.8841 7.91448C14.069 6.81655 13.829 5.7931 13.2414 5.10069C12.6315 4.43715 11.7547 4.08439 10.8552 4.14069H8.2869L7.05379 11.589V11.6607Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.8297,
    y: 4,
    width: 0.340563,
    height: 9,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1985 4L62 12H63.8015L65 4H63.1985Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72 4.00584H70.0371L69.4287 7.73859L68.0066 4.62505C67.8345 4.24398 67.477 4.00161 67.0846 4H66.3059L65 12H66.9629L67.5794 8.22052L69.0259 11.3808C69.2003 11.76 69.5585 11.9999 69.9506 12H70.6941L72 4.00584Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6416 5.98905L78 4H72.4424L71 12H76.5576L76.916 10.008H73.5265L73.7445 8.79591H76.4113L76.7696 6.80686H74.1028L74.2521 5.98905H77.6416Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3256 10.008L60.4151 4H58.236L57.0173 10.6944C56.9588 11.0182 57.0504 11.3506 57.2675 11.6024C57.4846 11.8542 57.8051 11.9998 58.1429 12H61.6398L62 10.008H59.3256Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1985 4L32 12H33.8015L35 4H33.1985Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.197 4L41 12H42.8005L44 4H42.197Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42 4.00584H40.0371L39.4287 7.73586L38.0093 4.62459C37.8353 4.2443 37.4775 4.00257 37.0846 4H36.3059L35 12H36.9737L37.5902 8.22328L39.0394 11.3812C39.2103 11.7556 39.5613 11.9947 39.9479 12H40.6914L42 4.00584Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6927 5.98905L33 4H29.8707C28.9239 4.00068 28.1141 4.7765 27.9501 5.84009L27 12H28.8592L29.356 8.78715H31.6428L31.9501 6.7981H29.6633L29.7887 5.98028L32.6927 5.98905Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54 4L53.4683 7.20409H51.7989L52.3306 4H50.3306L49 12H51L51.4683 9.19022H53.1377L52.6694 12H54.6694L56 4H54Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2801 5.98905H49.6656L50 4H46.4914C45.9748 4.00462 45.4967 4.28717 45.2256 4.7481C44.9545 5.20902 44.9284 5.78363 45.1565 6.26944L46.8286 9.8766C46.8425 9.90529 46.8408 9.93957 46.8242 9.96662C46.8076 9.99367 46.7785 10.0094 46.7478 10.008H44.3344L44 12H47.542C48.0619 12.0009 48.5453 11.72 48.8199 11.2573C49.0946 10.7946 49.1214 10.216 48.8909 9.72764L47.1965 6.1234C47.1827 6.09386 47.1848 6.05892 47.2019 6.03138C47.2191 6.00385 47.2487 5.98778 47.2801 5.98905Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5 11C77.2387 11 77.0211 11.2179 77 11.5009C77.0043 11.6385 77.0589 11.7686 77.1519 11.8623C77.2449 11.9559 77.3684 12.0053 77.4951 11.9995C77.7607 12.0116 77.9859 11.7893 78 11.5009C77.9789 11.2179 77.7613 11 77.5 11ZM77.7779 11.7918C77.7014 11.8689 77.5994 11.9092 77.4951 11.9034C77.3917 11.9082 77.2908 11.8674 77.2155 11.7903C77.1402 11.7131 77.0968 11.6062 77.0951 11.4938C77.0951 11.2518 77.2756 11.0557 77.4984 11.0557C77.7211 11.0557 77.9016 11.2518 77.9016 11.4938C77.8991 11.6072 77.8545 11.7147 77.7779 11.7918ZM77.3902 11.7823H77.3049V11.2231H77.518C77.6492 11.2231 77.7311 11.273 77.7311 11.3834C77.7311 11.4938 77.659 11.5187 77.5803 11.5294L77.7377 11.7858H77.6459L77.4852 11.5365H77.3902V11.7823ZM77.6328 11.3691C77.6328 11.4546 77.5738 11.4546 77.4951 11.4546H77.4098V11.2836H77.5082C77.5705 11.2836 77.6328 11.2836 77.6328 11.3691Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdFnlBrand);
export default __webpack_public_path__ + "static/media/JD_FNL_Brand.2545ac2249be28299d18af68d025ec9c.svg";
export { ForwardRef as ReactComponent };